
import React, { useState } from "react";
import { User } from "@/lib/auth";
import { BottomNavigation } from "@/components/navigation/BottomNavigation";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ChangePasswordDialog } from "./ChangePasswordDialog";
import { UserDocuments } from "./UserDocuments";
import { useHomeStats } from "@/hooks/useHomeStats";
import { useRecentActivity } from "@/hooks/useRecentActivity";
import { useAuth } from "@/hooks/AuthContext";
import { RecentActivity } from "@/components/home/admin/RecentActivity";
import { ProfileHeader } from "./ProfileHeader";
import { ProfileInfo } from "./ProfileInfo";
import { WorkStats } from "./WorkStats";
import { ProfileActions } from "./ProfileActions";
import { ProfileSettings } from "./ProfileSettings";

interface UserProfileProps {
  user: User;
}

export const UserProfile: React.FC<UserProfileProps> = ({ user }) => {
  const navigate = useNavigate();
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const { stats } = useHomeStats();
  const { activities, loading: activitiesLoading } = useRecentActivity();
  const { signOut } = useAuth();

  const handleLogout = async () => {
    try {
      await signOut();
      
      toast.success("Déconnexion réussie", {
        description: "À bientôt !",
        duration: 2000,
      });
      
      setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);
      toast.error("Erreur lors de la déconnexion");
    }
  };

  const handleChangePassword = () => {
    setShowChangePassword(true);
  };

  const handleSettings = () => {
    setShowSettings(true);
  };

  return (
    <div className="min-h-screen bg-[#F8F8F8] pb-24">
      <ProfileHeader onSettingsClick={handleSettings} />

      {/* Main Content */}
      <main className="pt-16 px-4 mt-4 pb-8">
        <div className="space-y-6 mb-8">
          <ProfileInfo user={user} />

          <UserDocuments userId={user.id} />

          <WorkStats stats={stats} />

          {/* Recent Activity - Using real data */}
          <div className="bg-white rounded-lg shadow-sm">
            <RecentActivity activities={activities} loading={activitiesLoading} />
          </div>

          <ProfileActions 
            onChangePassword={handleChangePassword}
            onLogout={handleLogout}
          />
        </div>
      </main>

      <BottomNavigation activeTab="profil" />

      <ProfileSettings 
        user={user}
        open={showSettings}
        onOpenChange={setShowSettings}
        onChangePassword={handleChangePassword}
      />

      <ChangePasswordDialog 
        open={showChangePassword}
        onOpenChange={setShowChangePassword}
      />
    </div>
  );
};
